// FirmaNotificacion.js — Nuevo componente para Solponiente
import React, { useState, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const FirmaNotificacion = ({ notificacion, onFirmada }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (window.AutoScript) {
      window.AutoScript.cargarAppAfirma();
    } else {
      console.error("AutoScript no está disponible.");
    }
  }, []);

  const sign = () => {
    setLoading(true);
    const contenido = btoa(notificacion.Descripcion);
    const fecha = new Date();

    window.AutoScript.sign(
      contenido,
      "SHA256withRSA",
      "CAdES",
      "",
      async (firma) => {
        try {
          await fetch(
            `https://oficinavirtual-solponiente.com/api/notificaciones/${notificacion.NotificacionID}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
              body: JSON.stringify({
                UsuarioID: notificacion.UsuarioID,
                SolicitudID: notificacion.SolicitudID,
                DocumentoID: notificacion.DocumentoID,
                Descripcion: notificacion.Descripcion,
                FechaEnvio: notificacion.FechaEnvio,
                Firmado: true,
                FechaFirma: notificacion.FechaFirma,
                Recepcion: true,
                FechaRecepcion: fecha
                  .toISOString()
                  .replace("T", " ")
                  .split("Z")[0],
              }),
            }
          );
          setLoading(false);
          alert("Notificación firmada correctamente");
          onFirmada();
        } catch (err) {
          alert("Error al actualizar notificación");
          setLoading(false);
        }
      },
      (type, message) => {
        alert("Error en firma: " + message);
        setLoading(false);
      }
    );
  };

  return (
    <Modal show centered>
      <Modal.Header>
        <Modal.Title>Firmar Notificación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Estás a punto de firmar esta notificación electrónicamente.</p>
        <p>¿Deseas continuar?</p>
        {loading && <Spinner animation="border" />}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onFirmada} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={sign} disabled={loading}>
          Firmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FirmaNotificacion;
